import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Link } from 'react-router-dom';
const NotFound = ()=>{
    return /*#__PURE__*/ _jsx("section", {
        className: "flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "text-center",
            children: [
                /*#__PURE__*/ _jsx("h1", {
                    className: "mb-4 text-8xl font-bold text-gray-300",
                    style: {
                        fontFamily: "'Caveat', cursive"
                    },
                    children: "404"
                }),
                /*#__PURE__*/ _jsx("h2", {
                    className: "mb-4 text-2xl font-bold text-gray-800",
                    children: "ページが見つかりません"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "mb-8 text-gray-600",
                    children: "お探しのページは存在しないか、移動した可能性があります。"
                }),
                /*#__PURE__*/ _jsx(Link, {
                    to: "/",
                    className: "inline-block rounded-full bg-teal-700 px-8 py-3 font-bold text-white transition-colors hover:bg-teal-800",
                    children: "トップページへ戻る"
                })
            ]
        })
    });
};
export default NotFound;
